import React, { ChangeEvent, useEffect, useContext } from 'react';
import Modal from 'react-bootstrap/Modal';
import { useDisclosure } from '@/hooks/useDisclosure';
import { Service } from '@/features/services/types';
import { CalendarUsers } from '@/features/Calendar/types';
import CloseNew from '@/assets/img/Close-new.svg';
import { BookAppointmentResponse } from '../types';
import { ReactComponent as MenuBackIcon } from '@/assets/img/menu-back-icon.svg';
import ServiceProviderIcon from '@/assets/img/user-default-icon.png';
import { BookAppointment1 } from '@/assets/img/BookAppointment-1';
import { BookAppointment2 } from '@/assets/img/BookAppointment-2';
import { BookAppointment3 } from '@/assets/img/BookAppointment-3';
import RoomBookingSuccessIcon from '@/assets/img/room-booking-success.png';
import { ReactComponent as CheckInIcon } from '@/assets/img/check-in.svg';
import { ReactComponent as CheckOutIcon } from '@/assets/img/check-out.svg';
import { useTranslation } from 'react-i18next';
import { useAuth } from '@/lib/auth';
import '../../Calendar/components/EditMember.scss';
import Utils from '@/utils/util';
import { UserContext } from '@/routes';
import { Business } from '@/features/communication';
import { Room } from '@/features/rooms';
import { PetConfirmationDisplay } from './PetConfirmationDisplay';
import { Pets } from '@/features/customers';
import { RecurringAppointment } from '../api/getRecurringSlots';
import moment from 'moment';
export type BookAppointmentDialogProps = {
  date: Date;
  startTime: Date;
  endTime: Date;
  services?: Service[];
  calendarUsers?: CalendarUsers[];
  alreadySelectedService?: Service;
  alreadySelectedUser?: CalendarUsers;
  onBookingconfirmed: () => void;
  bookingResponse: BookAppointmentResponse;
  email: string;
  phone: string;
  serviceProvider?: CalendarUsers;
  selectedSlot?: any;
  business?: Business;
  selectedAddons: Service[];
  selectedRoom?: Room;
  selectedProviders?: CalendarUsers[];
};

export const BookAppointmentDialog = ({
  services,
  calendarUsers,
  alreadySelectedService,
  alreadySelectedUser,
  onBookingconfirmed,
  bookingResponse,
  phone,
  serviceProvider,
  selectedSlot,
  business,
  selectedAddons,
  selectedRoom,
  selectedProviders,
}: BookAppointmentDialogProps) => {
  const userContext = useContext(UserContext);
  const { close, open, isOpen } = useDisclosure();
  const { t, i18n } = useTranslation();
  const cancelButtonRef = React.useRef(null);
  const [showMoreRecurring, setShowMoreRecurring] = React.useState(false);
  const data = bookingResponse?.appointment ? bookingResponse.appointment : bookingResponse;
  const petDetails = bookingResponse?.appointment?.petDetails
    ? bookingResponse?.appointment.petDetails
    : bookingResponse.pet;

  const getContent = () => {
    return (
      <>
        {((userContext && userContext?.isLandscape) || selectedSlot) && (
          <div className=" flex justify-center">
            <img
              onClick={() => {
                close();
                onBookingconfirmed();
              }}
              ref={cancelButtonRef}
              src={CloseNew}
              className="Close"
            />
          </div>
        )}
        <div>
          <div className="top-ico-svg">
            {selectedRoom ? (
              <img className="room-booking-success" src={RoomBookingSuccessIcon} />
            ) : (
              <BookAppointment1 />
            )}
          </div>
          <div className="modal-title-app">
            {selectedRoom
              ? bookingResponse.accomodationType === Utils.ACCOMODATION_TYPES.DAY_CARE
                ? 'Daycare has been booked'
                : 'Boarding has been booked'
              : 'Appointment has been scheduled'}
          </div>
          <div className="modal-desc-app">
            {selectedRoom
              ? t('Congratulations! the room for furry mate has been reserved successfully.')
              : t(
                'Congratulations! the appointment for your furry mate has been confirmed successfully.'
              )}
          </div>
          {bookingResponse.accomodationType != Utils.ACCOMODATION_TYPES.BOARDING && (
            <div className="Scheduled-info info-panel-padding">
              <div className="sche-info">
                <div>
                  <BookAppointment2 />
                </div>
                <div>
                  <div className="Scheduled-time">
                    {Utils.formatDateStringTz(
                      selectedRoom
                        ? bookingResponse?.startTime
                        : bookingResponse?.appointment?.startTime,
                      business?.timezone
                    )}
                  </div>
                  <div className="Scheduled-title">Scheduled date</div>
                </div>
              </div>
              <div className="sche-info">
                <div>
                  <div>
                    <BookAppointment3 />
                  </div>
                </div>
                <div>
                  <div className="Scheduled-time">
                    {`${Utils.getAMPMtimeWithoutFormat(
                      selectedRoom
                        ? bookingResponse?.startTime
                        : bookingResponse?.appointment?.startTime,
                      business?.timezone
                    )} - ${Utils.getAMPMtimeWithoutFormat(
                      selectedRoom
                        ? bookingResponse?.endTime
                        : bookingResponse?.appointment?.endTime,
                      business?.timezone
                    )}`}

                    <span className="text-gray-500 text-sm">
                      {' ' + Utils.getTzAbbr(business?.timezone)}
                    </span>
                  </div>
                  <div className="Scheduled-title">Scheduled time</div>
                </div>
              </div>
            </div>
          )}
          {bookingResponse.accomodationType === Utils.ACCOMODATION_TYPES.BOARDING && (
            <div className="Scheduled-info info-panel-padding">
              <div className="sche-info">
                <div>
                  <CheckInIcon className="mt-0" />
                </div>
                <div>
                  <div className="Scheduled-time">
                    {Utils.formatDateStringTz(
                      data?.startTime,
                      business?.timezone,
                      "DD MMM 'YY, hh:mmA"
                    )}
                    <span className="text-gray-500 text-sm">
                      {' '}
                      {Utils.getTzAbbr(business?.timezone)}
                    </span>
                  </div>
                  <div className="Scheduled-title">
                    {' '}
                    {selectedRoom ? 'Check-in time' : 'Scheduled date'}
                  </div>
                </div>
              </div>
              <div className="sche-info">
                <div>
                  <div>
                    <CheckOutIcon className="mt-0" />
                  </div>
                </div>
                <div>
                  <div className="Scheduled-time">
                    {Utils.formatDateStringTz(
                      data?.endTime,
                      business?.timezone,
                      "DD MMM 'YY, hh:mmA "
                    )}

                    <span className="text-gray-500 text-sm">
                      {' ' + Utils.getTzAbbr(business?.timezone)}
                    </span>
                  </div>
                  <div className="Scheduled-title">Check-out time</div>
                </div>
              </div>
            </div>
          )}

          <div className="info-block">
            {data?.pets && data?.pets.length > 0 && (
              <div className="cust-details pets">
                <div className="detail-bl-outer">Pet detail</div>
                <div className="info-outer">
                  <div className="pet-list-display">
                    {data?.pets.map((pet: Pets, index: number) => (
                      <PetConfirmationDisplay
                        key={`pet-info${index}`}
                        data={pet}
                        showPrice={false}
                      />
                    ))}
                  </div>
                </div>
              </div>
            )}
            {data?.bookedSlots && (
              <div className="cust-details">
                <div className="detail-bl-outer">Recurring detail</div>
                <div className="info-outer-parent">
                  {data.bookedSlots.map((slot: any, index: number) =>
                    showMoreRecurring || (!showMoreRecurring && index <= 2) ? (
                      <div className="info-outer mb-2" key={`recurring-info${index}`}>
                        <div className="new-cust-name slots">{slot?.date}</div>
                        <div className="new-cust-cell">{`${slot?.time} - ${slot.timeEnd}`}</div>
                      </div>
                    ) : (
                      <></>
                    )
                  )}
                  {data?.bookedSlots?.length > 3 && (
                    <div className="recurring-action">
                      <span
                        className="c-pointer"
                        onClick={() => setShowMoreRecurring(!showMoreRecurring)}
                      >
                        + {showMoreRecurring ? t('View less dates') : t('View all dates')}
                      </span>
                    </div>
                  )}
                </div>
              </div>
            )}
            <div className="cust-details">
              <div className="detail-bl-outer">{t('Customer detail')}</div>
              <div className="info-outer">
                {bookingResponse.accomodationType ? (
                  <>
                    <div className="new-cust-name capitalize-text">
                      {bookingResponse?.petParent
                        ? bookingResponse?.petParent?.name
                        : bookingResponse.parentName}
                    </div>
                    <div className="new-cust-cell">
                      {Utils.formatPhoneNumber(
                        bookingResponse?.petParent && bookingResponse?.petParent?.phone
                          ? bookingResponse?.petParent?.phone
                          : bookingResponse?.parentPhone
                      )}
                    </div>
                  </>
                ) : (
                  <>
                    {' '}
                    <div className="new-cust-name capitalize-text">
                      {bookingResponse?.appointment?.petParent
                        ? bookingResponse?.appointment?.petParent?.name
                        : bookingResponse?.appointment.parentName}
                    </div>
                    <div className="new-cust-cell">
                      {Utils.formatPhoneNumber(
                        bookingResponse?.appointment?.petParent &&
                          bookingResponse?.appointment?.petParent?.phone
                          ? bookingResponse?.appointment?.petParent?.phone
                          : bookingResponse?.appointment?.parentPhone
                      )}
                    </div>
                  </>
                )}
              </div>
            </div>
            {!selectedRoom && (
              <div className="cust-details">
                <div className="detail-bl-outer">Service detail</div>
                <div className="info-outer-parent">
                  <div className="info-outer">
                    <div className="new-cust-name">{alreadySelectedService?.name}</div>
                    <div className="new-cust-cell">
                      {Utils.getDurationDiff(data?.startTime, data?.endTime)}
                    </div>
                  </div>
                  {selectedAddons && selectedAddons?.length > 0 && (
                    <div className="addon-services">
                      <ul>
                        {' '}
                        {selectedAddons.map((addonService) => (
                          <li>+ {addonService.name}</li>
                        ))}
                      </ul>
                    </div>
                  )}
                </div>
              </div>
            )}
            {!selectedRoom && (
              <>
                {userContext && userContext?.isLandscape ? (
                  <>
                    <div className="cust-details">
                      <div className="detail-bl-outer">{t('Service provider')}</div>
                      <div className="pp-outer">
                        <div className="flex-shrink-0">
                          <img
                            className="user-profile-icon mr-3"
                            src={
                              serviceProvider && serviceProvider.avatarUrl
                                ? serviceProvider.avatarUrl
                                : ServiceProviderIcon
                            }
                          />
                        </div>
                        <div>
                          <div className="pp-name">{data.providerName}</div>
                          <div className="pp-email">{data.providerEmail}</div>
                        </div>
                      </div>
                    </div>
                    {selectedProviders && selectedProviders?.length > 0 && (<div className="cust-details">
                      <div className="detail-bl-outer">{t('Assistant Groomers')}</div>
                      <div>
                        {selectedProviders?.map((serviceProvider, index) => (
                          <div className="pp-outer mb-4" key={`assistant-${index}`}>
                            <div className="flex-shrink-0">
                              <img
                                className="user-profile-icon mr-3"
                                src={
                                  serviceProvider && serviceProvider.avatarUrl
                                    ? serviceProvider.avatarUrl
                                    : ServiceProviderIcon
                                }
                              />
                            </div>
                            <div>
                              <div className="pp-name">{serviceProvider.name}</div>
                              <div className="pp-email">{serviceProvider.email}</div>
                            </div>
                          </div>))}

                      </div>
                    </div>)
                    }
                  </>
                ) : (
                  <>
                    <div className="cust-details">
                      <div className="detail-bl-outer">{t('Service provider')}</div>{' '}
                      <div className="info-outer ml-50">
                        <div className="new-cust-name">{data.providerName}</div>
                        <div className="new-cust-cell">{data.providerEmail}</div>
                      </div>
                    </div>
                    {
                      selectedProviders && selectedProviders?.length > 0 && (<div className="cust-details">
                        <div className="detail-bl-outer">{t('Assistant Groomers')}</div>{' '}
                        <div className="info-outer ml-50">
                          {selectedProviders?.map((serviceProvider, index) => (
                            <div className="mb-4" key={`assistant-mobile-${index}`}>
                              <div className="new-cust-name">{serviceProvider.name}</div>
                              <div className="new-cust-cell">{serviceProvider.email}</div>
                            </div>))}
                        </div>
                      </div>)
                    }
                  </>
                )}
              </>
            )}
            {selectedRoom?.name && (
              <div className="cust-details">
                <div className="detail-bl-outer">{t('Room detail')}</div>
                <div className="info-outer room">
                  <div className="new-cust-name" title={selectedRoom?.name}>
                    {selectedRoom?.name}
                  </div>{' '}
                  <div className="new-cust-name desc mt-2" title={selectedRoom?.description}>
                    {selectedRoom?.description}
                  </div>
                </div>
              </div>
            )}
          </div>
        </div >
      </>
    );
  };
  return (
    <>
      {(userContext && userContext?.isLandscape) || selectedSlot ? (
        <Modal
          show={true}
          onHide={() => {
            close();
            onBookingconfirmed();
          }}
          initialFocus={cancelButtonRef}
          className="petsked-modal-dialog booked-appointment-modal"
        >
          <div className="content">{getContent()}</div>
        </Modal>
      ) : (
        <>
          <div className="confirm-appoitment-mobile">
            <div
              className="menus-back-nav"
              onClick={() => {
                close();
                onBookingconfirmed();
              }}
            >
              <MenuBackIcon /> <span>{t('Back')}</span>
            </div>
            <div className="mobile-bg-white">{getContent()}</div>
          </div>
        </>
      )}
    </>
  );
};
